import { useCallback } from "react";
import { toast } from "sonner";

import { m } from "@recobra/i18n/messages";

import { documentsApi, HttpError } from "../lib/api";

export const useDocumentViewer = () =>
  useCallback(
    async ({
      documentId,
      windowName,
    }: {
      documentId: string;
      windowName: string;
    }): Promise<void> => {
      // Open synchronously within the user gesture so awaiting the fresh signed
      // URL does not cause popup blockers to reject the window.
      const popup = window.open("", windowName, getViewerWindowFeatures());

      try {
        const { viewUrl: freshUrl } = await documentsApi.getViewUrl(documentId);
        if (popup) popup.location.href = freshUrl;
      } catch (error) {
        popup?.close();
        const fileMissing = error instanceof HttpError && error.status === 410;
        toast.error(fileMissing ? m.doc_view_file_missing() : m.doc_view_error());
      }
    },
    [],
  );

const getViewerWindowFeatures = (): string => {
  const width = 1000;
  const height = 800;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  return `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes`;
};
